import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "recharge-history-drawer" }
const _hoisted_2 = { class: "balance-status-tool-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-wenhao_tianchong" }, null, -1)

import STable from '@/components/Table/index.vue'
import { t } from '@/plugins/i18n'
import { reactive, ref, computed, nextTick } from 'vue'
import Drawer from '@/components/common/Drawer.vue'
import { getBalanceHistoryListApi, uploadVoucher } from '@/apis/fund'
import { historyColumns } from '../data'
import { clearForm, getJapanTime } from '@/util/common'
import { FormInstance, ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { isMultiStore } from '@/store'


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const visible = ref(false)
const store = useStore()
const historyTable = ref()
const pageData = ref({
  page: 1,
  limit: 10
})

const route = useRoute()
// 币种
const currencyCode = computed(() => {
  const { currencyCode = 'CNY' } = route.query
  // 如果没开通多仓，直接展示人民币
  if (!isMultiStore()) return 'CNY'
  return currencyCode
})

const balanceRechargeStatusDict: any = {
  1: t('待初审'),
  2: t('待终审'),
  3: t('已通过'),
  4: t('已拒绝'),
  5: t('充值失败'),
  6: t('系统确认中'),
  7: t('充值撤回')
}
const setFile = (file: any, row: any) => {
  if (file?.raw.url) {
    uploadVoucher({
      voucherUrl: file?.raw.url || '',
      balanceRechargeId: row.balanceRechargeId
    }).then((res: any) => {
      if (res.success) {
        ElMessage.success(t('上传成功'))
        historyTable.value.getData()
      }
    })
  }
}
const filterData = computed(() => {
  return {
    customerId: store.getters.user.customerId,
    rechargeCurrencyCode: currencyCode.value
  }
})
const open = () => {
  visible.value = true
  pageData.value = {
    page: 1,
    limit: 10
  }
  historyTable.value && historyTable.value.getData()
}
const close = () => {
  visible.value = false
}
expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Upload = _resolveComponent("Upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Drawer, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: _unref(t)('充值记录'),
      showBtn: false,
      size: "70%",
      onBeforeClose: close
    }, {
      default: _withCtx(() => [
        _createVNode(STable, {
          api: _unref(getBalanceHistoryListApi),
          columns: _unref(historyColumns),
          "page-data": pageData.value,
          "onUpdate:page-data": _cache[0] || (_cache[0] = ($event: any) => ((pageData).value = $event)),
          ref: (_value, _refs) => {
            _refs['historyTable'] = _value
            historyTable.value = _value
          },
          filterData: _unref(filterData)
        }, {
          fundFlowNo: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.fundFlowNo||'--'), 1)
          ]),
          rechargeArrivalTime: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.payChannel === "1" ? (row.uploadedVoucher ? row.rechargeArrivalTime : row.createTime) : row.payChannel === "5" ? (row.createTime) : row.rechargeArrivalTime)), 1)
          ]),
          balanceRechargeStatus: _withCtx(({ row }) => [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(row.payChannel==='5' && row.bizType === 41 ? _unref(t)('充值成功') : (balanceRechargeStatusDict[(row.balanceRechargeStatus === '3' && row.rechargeType === 2) ? 7 : row.balanceRechargeStatus] )) + " ", 1),
              (row.payChannel==='5' && row.balanceRechargeStatus === '6')
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    effect: "light",
                    placement: "top",
                    "popper-class": "balance-status-tool"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('系统确认中的状态是指银行到账通知时间存在差异，如超过3天状态未变更，请先联系当地银行确认打款是否成功，再联系客服处理')), 1)
                    ]),
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          remittanceAmount: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.remittanceAmount) + "(" + _toDisplayString(row.remittanceCurrencyCode) + ") ", 1),
            _createElementVNode("div", null, [
              (!row.uploadedVoucher && row.balanceRechargeStatus == 2 && row.payChannel === '3')
                ? (_openBlock(), _createBlock(_component_Upload, {
                    key: 0,
                    "limit-file": { accept: '.jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.pdf' },
                    onChange: ($event: any) => (setFile($event, row))
                  }, {
                    trigger: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "text",
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('点击上传凭证')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["limit-file", "onChange"]))
                : _createCommentVNode("", true)
            ])
          ]),
          payChannel: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.payChannel === "1" ? _unref(t)('銀行振込') : '') + " " + _toDisplayString(row.payChannel === "2" ? 'paypal' : '') + " " + _toDisplayString(row.payChannel === "3" ? 'payoneer' : '') + " " + _toDisplayString(row.payChannel === "4" ? _unref(t)('paypal信用卡') : '') + " " + _toDisplayString(row.payChannel === "5" ? _unref(t)('银行卡便捷支付') : ''), 1)
          ]),
          _: 1
        }, 8, ["api", "columns", "page-data", "filterData"])
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})